import { getViewData } from '../modules/view-data';

export default {
    /**
     * Provide our getViewData to Vue
     *
     * @param {Object} Vue
     */
    install(Vue) {
        Vue.prototype.$getViewData = getViewData;
    },
};
